import * as React from 'react';

import PropTypes from 'prop-types';

import {
  HorizontalYellowLineShape2,
  HorizontalYellowLineShape3,
  RoundedArrow,
  VerticalYellowLineShape,
} from '../../Atoms/Icons/Icons';
import { removeHtmlTag } from '../../Utils/Utils';

import './TitleSection.scss';
let classNames = require('classnames');

function TitleSection({
  forceTagH1,
  title,
  subtitle,
  description,
  normalText,
  type,
  h2color,
  h3color,
  h4color,
  iconColor,
  customClass,
  rtl
}) {
  return (
    <>
      {title && (
        <div
          className={classNames(`title_section type_${type} ${customClass ? customClass : ''} ${rtl ? 'rtl' : ''}`)}
        >
          {type === 'arrow' ? (
            <div className={classNames('arrow', 'icon')}>
              <RoundedArrow color={iconColor} aria-hidden="true" />
            </div>
          ) : type === 'line' ? (
            <div className={classNames('line', 'icon')}>
              <VerticalYellowLineShape aria-hidden="true" />
            </div>
          ) : type === 'line1' ? (
            <div className={classNames('line1', 'icon')}>
              <HorizontalYellowLineShape3 aria-hidden="true" />
            </div>
          ) : type === 'no_line' ? (
            <></>
          ) : (
            <div className={classNames('line2', 'icon')}>
              <HorizontalYellowLineShape2 aria-hidden="true" />
            </div>
          )}
          <div className="title_text">
            {forceTagH1 ? (
              <h1
                className={classNames('h2', `color_${h3color}`)}
                dangerouslySetInnerHTML={{ __html: title }}
              ></h1>
            ) : (
              <h2
                className={`color_${h2color}`}
                dangerouslySetInnerHTML={{ __html: title }}
              ></h2>
            )}
            {subtitle && (
              <p
                className={classNames('h4', `color_${h4color}`)}
                dangerouslySetInnerHTML={{ __html: removeHtmlTag(subtitle) }}
              ></p>
            )}
            {description && (
              <p
                className={classNames('h5', `color_${h4color}`)}
                dangerouslySetInnerHTML={{ __html: removeHtmlTag(description) }}
              ></p>
            )}
            {normalText && (
              <p className="normal_text">{removeHtmlTag(normalText)}</p>
            )}
          </div>
        </div>
      )}
    </>
  );
}

TitleSection.defaultProps = {
  //title: 'Title',
  type: 'arrow',
  h3color: 'bleu',
  h2color: 'bleu',
  h4color: 'bleu',
  iconColor: 'color_yellow',
};

TitleSection.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  type: PropTypes.string,
  h2color: PropTypes.string,
  h3color: PropTypes.string,
  h4color: PropTypes.string,
  iconColor: PropTypes.string,
};

export default TitleSection;
